import React from 'react';
import MetricItem from './MetricItem';
import FacebookCampaigns from './FacebookCampaigns';
var FacebookMetrics = function (_a) {
    var _b;
    var data = _a.data;
    var _c = React.useState(false), modalOpen = _c[0], setModalOpen = _c[1];
    if (!data) {
        return React.createElement("div", { className: "px-4 py-3 text-gray-500 italic text-center" }, "Sem campanha ativa");
    }
    var isPrepaid = data.account_type === "Pré-paga";
    // Cálculo dos dias restantes de saldo
    var daysRemaining = "-";
    var daysLabel = "dias";
    if (isPrepaid &&
        typeof data.available_balance === "number" &&
        typeof data.daily_budget === "number" &&
        data.daily_budget > 0) {
        var calcDays = Math.floor(data.available_balance / data.daily_budget);
        daysRemaining = calcDays;
        daysLabel = calcDays <= 1 ? "dia" : "dias";
    }
    else if (isPrepaid && typeof data.days_remaining === "number") {
        daysRemaining = data.days_remaining;
        daysLabel = data.days_remaining === 1 ? "dia" : "dias";
    }
    var actIdRaw = data === null || data === void 0 ? void 0 : data.FB_AccountID;
    var actId = typeof actIdRaw === "string" ? actIdRaw.replace("act_", "") : "";
    // Helper para calcular custo por ação
    var calculateCostPerAction = function (cost, actions) {
        if (actions > 0) {
            return (cost / actions).toFixed(2).replace('.', ',');
        }
        return '0,00';
    };
    return (React.createElement("div", { className: "p-0.5 2xl:p-1 2xl:p-2 grid grid-cols-4 gap-0.5 2xl:gap-2 w-full" },
        React.createElement(MetricItem, { label: "Alcance", value: "".concat((_b = data.reach) !== null && _b !== void 0 ? _b : "-"), account_stopped: data === null || data === void 0 ? void 0 : data.account_stopped, color: "#38bdf8", size: "large" }),
        React.createElement(MetricItem, { label: "Gasto", value: typeof data.spend === "number"
                ? "R$ ".concat(data.spend.toFixed(2).replace('.', ','))
                : "-", color: "#22c55e", size: "large" }),
        React.createElement(MetricItem, { label: "Saldo", value: isPrepaid
                ? (typeof data.available_balance === "number"
                    ? (typeof daysRemaining === "number" && daysRemaining >= 0 && data.campaigns && data.campaigns.length > 0
                        ? "R$ ".concat(data.available_balance.toFixed(2).replace('.', ','), " | ").concat(daysRemaining, " ").concat(daysLabel)
                        : "R$ ".concat(data.available_balance.toFixed(2).replace('.', ',')))
                    : "-")
                : "Conta Pós paga", color: isPrepaid ? "#facc15" : "#64748b", size: "large", link: actId ? "https://www.facebook.com/ads/manager/billing/transactions?act=".concat(actId) : undefined, daysRemaining: isPrepaid && typeof daysRemaining === "number" ? daysRemaining : undefined, classAdd: "col-span-2" }),
        React.createElement("div", { className: "col-span-4 grid grid-cols-2 gap-2" },
            data.campaigns && data.campaigns.length > 0 ? (React.createElement("div", { className: "col-span-4 grid grid-cols" },
                React.createElement("div", { className: "text-xs 2xl:text-lg border border-gray-700 rounded-lg bg-gray-800/60 text-gray-400 shadow-md flex items-center opacity-70 cursor-pointer hover:opacity-100 hover:border-orange-400 transition-all px-1 2xl:px-3 py-4", title: "Clique para ver detalhes", onClick: function () { return setModalOpen(true); } },
                    "Acessar Campanhas Meta ADS",
                    React.createElement("span", { className: "inline-flex items-center justify-center w-5 h-5 ml-2 rounded-full bg-green-500 text-white text-[11px] font-bold" }, data.campaigns.length)))) : (React.createElement("div", { className: "col-span-4 text-center text-gray-500 italic" }, "Nenhuma Campanha Ativa.")),
            React.createElement(FacebookCampaigns, { data: data.campaigns, open: modalOpen, onClose: function () { return setModalOpen(false); }, maxWidth: "max-w-[95vw]", accountId: data.FB_AccountID, pageId: data.page_id }))));
};
export default FacebookMetrics;
